import Manual from './manual';
import BasicRule from './basicRule';
import CustomizedRule from './customizedRule';

export const roleTarget = {
  USER: '按员工',
  USER_GROUP: '按团队'
};

export const settingMap = [
  {
    key: 'MANUAL',
    title: '手动分配',
    content: '操作人员在线索列表中人工分配',
    view: Manual,
  },
  {
    key: 'BASIC_RULE',
    title: '基础规则分配',
    content: '根据所选基础规则自动分配线索',
    view: BasicRule,
  },
  {
    key: 'CUSTOMIZED_RULE',
    title: '自定义规则分配',
    content: '可自定义分配规则分配线索',
    view: CustomizedRule,
  },
];

export const employeeStrategyMap = [
  {
    key: 'RULE_TOTAL_AVG',
    title: '按员工线索量补齐分配',
    desc: '当有新线索时，系统查看所有可接收线索的员工近一周被分配的线索数量， 优先分配给线索数量最少的员工',
  },
  {
    key: 'RULE_TAG_AVG',
    title: '按员工未跟进线索量补齐',
    desc: '当有新线索时，系统查看所有可接收线索的员工近一周被分配的未跟进线索数量，优先分配给未跟进线索数量最少的员工',
  },
  {
    key: 'RULE_ASSIGNED_IN_ORDER',
    title: '按员工顺序循环分配',
    desc: '当有新线索时，系统按照已选择的员工顺序自动在员工间轮流分配线索',
  },
];

export const groupStrategyMap = [
  {
    key: 'RULE_TOTAL_AVG',
    title: '按团队线索量补齐分配',
    desc: '当有新线索时，系统统计有开启线索接收状态员工所属团队近一周被分配的线索数量，然后优先分配给线索数量最少的团队，团队内按照线索量补齐分配给线索数量最少且是开启线索接收状态的员工。',
  },
  {
    key: 'RULE_TAG_AVG',
    title: '按团队未跟进线索数量补齐分配',
    desc: '当有新线索时，系统统计有开启线索接收状态员工所属团队近一周被分配的未跟进线索数量，然后优先分配给未跟进线索数量最少的团队，团队内按照未跟进线索量补齐分配给未跟进线索数量最少的员工。',
  },
  {
    key: 'RULE_ASSIGNED_IN_ORDER',
    title: '按团队顺序轮流分配',
    desc: '当有新线索进来时，系统仅在所有开启线索接收状态员工的团队中，按照已选择的团队顺序自动在团队间轮流分配线索，团队内按照员工顺序轮流分配线索。',
  },
];

export const scopeMap = {
  leadsSource: '线索来源',
  leadsSubSource: '二级线索来源',
  actionSubType__leadsSubType: '线索类型',
  campaignId: '推广计划ID',
  adId: '广告ID',
  componentId: '组件ID',
  pageId: '落地页ID',
  area: '所在地',
  uid__wechatAppId: '账户ID',
  agencyId: '服务商ID',
  telLocation: '号码归属地',
  bundle: '表单内容',
};

export const placeholderMap = {
  leadsSource: '线索来源',
  leadsSubSource: '二级线索来源',
  actionSubType: '线索类型',
  campaignId: '请输入推广计划ID，多个推广计划ID请以英文逗号分开，例如：xxxxxxx',
  adId: '请输入广告ID，多个广告ID请以英文逗号分开，例如：xxxxxxx',
  componentId: '请输入组件ID，多个组件ID请以英文逗号分开，例如：xxxxxxx',
  pageId: '请输入落地页ID，多个落地页ID请以英文逗号分开，例如：xxxxxxx',
  area: '请输入关键字，多个关键字请以英文逗号隔开，例如：北京',
  telLocation: '请输入号码归属地，多个请以英文逗号隔开',
  bundle: '请输入关键字，多个关键字请以英文逗号隔开，例如：经销商',
};

export default {
  scopeMap,
  settingMap,
  employeeStrategyMap,
  groupStrategyMap,
  roleTarget,
};
